import { lazy, Suspense } from "react";
import type { KitTitleFormat } from "@termclear/contracts";

const RichTermTitle = lazy(() => import("./content/RichTermTitle"));

export function TermTitle(props: { name: string; format: KitTitleFormat }) {
  if (props.format === "plain") return <>{props.name}</>;
  return (
    <Suspense fallback={<>{props.name}</>}>
      <RichTermTitle name={props.name} format={props.format} />
    </Suspense>
  );
}
